<div>
    <div class="row ">
      <div class="col pl-3">
        <h4 class="mb-0 font-header" style="font-weight: 700;" ><label (click)="MovetoClientParent()"><i
            title="Close"  class="fa fa-chevron-circle-left" style="font-size:24px" title="Close"></i></label>&nbsp;Employee Report</h4>
      </div>
    </div>
    <div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
      <div class="row mt-4 ">
          <div class="col ">
              <div widget class="card border-0 box-shadow">
                  <div class="card-body  widget-body pt-2">
                      <div class="text-center text-danger">
                          <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                              agency to view
                              details</label>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
 <!-- list -->
<div class="row mt-4" *ngIf="global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
    <div class="col ">
        <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pt-2">
                <div class="row mt-2 ">
                    <div class="col-lg-4 pl-1">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Status </label>
                        </div>
                        <div class="col-lg-12 d-inline-flex">
                            <ng-select class="w-100" [(ngModel)]="ReportstatusLid" [searchable]="true"
                                [clearable]="true" [items]="ClientStatusList" bindLabel="lovName"
                                bindValue="id"></ng-select>
                        </div>
                    </div>

                     <div class="col-lg-4 pl-1">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Employee</label>
                        </div>
                        <div class="col-lg-12 v">
                            <ng-select class="w-100" [(ngModel)]="employeeId" [searchable]="true" [clearable]="true"
                                [items]="QpEmployeeDropDown" bindLabel="Value" bindValue="Key">
                            </ng-select>
                        </div>
                    </div> 
                     <div class="col-lg-4 pl-1">
                            <div class="col-lg-12">
                                <label style="font-weight:bold" class="mt-3"> </label>
                            </div>
                            <div class="col-lg-12 ">
                                <button type="button" class="btn blue-btn btn-sm" (click)="ApplyFilter()">Apply</button>&nbsp;&nbsp;
                                    <button class="btn blue-btn btn-sm ml-2" type="button" (click)="RefreshFilter()">
                                        <i class="fa fa-repeat"> </i>Refresh
                                    </button>&nbsp;&nbsp;
                                     <button type="button" class="btn blue-btn btn-sm  ml-1"
                            [disabled]=" !isEnabledExcel" (click)="exportEmployeeReportCsv()">
                            <i class="fa fa-file-excel-o mr-1"></i>Export</button>&nbsp;&nbsp;
                            </div>
                        </div>
                </div>
                <div class="row mt-4">
          <div class="col-12">
                <ejs-grid #gridEmployeeReport [dataSource]='data | async' [allowResizing]='true' [allowSorting]='true'
                    allowPaging='true' [allowFiltering]='true' [pageSettings]='initialPage'
                    [filterSettings]='filterOptions' (dataStateChange)='dataStateChange($event)'
                    (actionBegin)="onActionComplete($event)" (resizeStop)="onResize($event)" [showColumnChooser]='true'
                    [allowExcelExport]='true'>
                    <e-columns >
                        <e-column minWidth=150 width="100" field="name" headerText="Employee Name" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=150 width="100" field="userDetail.userRole" headerText="User Role" type="string" [allowFiltering]='false'
                            [allowSorting]='false'>
                        </e-column>
                        <e-column minWidth=150 width="100" field="dob" headerText="DOB" type='date' [allowFiltering]='false'
                            [allowSorting]='false' [format]='formatOptions'>
                        </e-column>
                        <e-column minWidth=150 width="100" field="age" headerText="Age" type='number'></e-column>
                        <e-column minWidth=80 width="100" field="email" headerText="Email" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                         <e-column minWidth=100 width="100"  field="phone1" headerText="Phone1" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 width="100"  field="phone2" headerText="Phone2" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=150 width="100" field="street" headerText="Street" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                         <e-column minWidth=80 width="100" field="zipcode" headerText="ZIP Code" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                         <e-column minWidth=100 width="100" field="statusLidName" headerText="Status" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-dropdownlist id='dropdown' placeholder='Select a Status'
                                    [dataSource]='EmployeeReportDropData' [popupHeight]='height'>
                                </ejs-dropdownlist>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 width="100" field="locationName" headerText="Location" type='string'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                          <e-column minWidth=80 width="100" field="language" headerText="Language" type='string' [allowFiltering]='false'
                        [allowSorting]='false'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column width="50" [showInColumnChooser]='false'>
                            <ng-template #headerTemplate let-data>
                                <div class="d-none d-lg-block">
                                    <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                                        </i></span>
                                </div>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
                <div *ngIf="EmployeeReportList.length == 0" class="text-center" style="color:red">
                    <p>No data available</p>
                </div>
            </div>
        </div>
    </div>
</div>
  </div>
  </div>
</div>
<!-- ClientBirthDayModal -->
<span id="openBirthDayModal" data-bs-toggle="modal" data-bs-target="#ClientBirthDayModal"></span>
<div class="modal fade" id="ClientBirthDayModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Client BirthDay Report</span>
                </h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="clearModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-5">
                        <label>Start Date&nbsp;<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <my-date-picker  placeholder="mm/dd/yyyy"
                            [selDate]="BirthDayReport.fromDate"
                            (inputFieldChanged)="BirthDayReportDateChanges($event,'inputchange','BirthDayfromDate')"
                            (dateChanged)="BirthDayReportDateChanges($event,'datechanged','BirthDayfromDate')">>
                        </my-date-picker>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-lg-5">
                        <label>End Date&nbsp;<sup class="super-script">*</sup></label>
                    </div>
                    <div class="col-lg-7">
                        <my-date-picker  placeholder="mm/dd/yyyy"
                            [selDate]="BirthDayReport.endDate"
                            (inputFieldChanged)="BirthDayReportDateChanges($event,'inputchange','BirthDayEndDate')"
                            (dateChanged)="BirthDayReportDateChanges($event,'datechanged','BirthDayEndDate')">
                        </my-date-picker>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <!-- <button class="btn blue-btn btn-sm" [disabled]="BirthDayReport.fromDate==null || BirthDayReport.fromDate==undefined || BirthDayReport.fromDate=='' ||
          BirthDayReport.endDate==null || BirthDayReport.endDate==undefined || BirthDayReport.endDate=='' "
                    (click)="getClientBirthdayReport();" > <span>Generate Report</span> </button> -->
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="clearModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="OpenCBirthDayModal" data-bs-toggle="modal" data-bs-target="#CBirthDayModal"></span>
<div class="modal fade" id="CBirthDayModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">{{reptitle}}</h5>
                <div class="text-right">
                    <button class="btn blue-btn btn-sm mr-2" (click)="closeGenerateModal()">
                        Close</button>
                </div>
            </div>
            <div class="modal-body" style="height:600px">
                <ng-container *ngIf="ViewReport== true">
                    <div style="width: 100%;height:100%" class="report-border" #reportContainer></div>
                    
                </ng-container>
            </div>
        </div>
    </div>
</div>


<span id="openinactive" data-bs-toggle="modal" data-bs-target="#inactiveModal"></span>
<div class="modal fade" id="inactiveModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog mw-100">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Inactive Client</h5>
                <div class="text-right">
                    <button class="btn blue-btn btn-sm mr-2" (click)="InactiveClientModal()">
                        Close</button>
                </div>
            </div>
            <div class="modal-body" style="height:600px">
                <app-client-report-inactive *ngIf="isClientReportInactive">

                </app-client-report-inactive>
               
            </div>
        </div>
    </div>
</div>